import FiltersCollectionList from '../Collections/FiltersCollectionList.js';
import FiltersMetadata       from '../Entities/FiltersMetadata.js';
import FiltersItem           from '../Entities/FiltersItem.js';
import FiltersItemCondition  from './FiltersItemCondition.js';

export { FiltersData as default };

/**
* Filters Data
*
* @author      rsimoes <ruben-r-simoes@telecom.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class FiltersData
{
  /**
   * Filters List Entity
   *
   * @public
   *
   * @type {FiltersCollectionList}
   *
   * @since 7.0.0
   */
  filters = new FiltersCollectionList('id');

  /**
   * Filters Metadata entity
   *
   * @public
   *
   * @type {FiltersMetadata}
   *
   * @since 7.0.0
   */
  metadata = new FiltersMetadata();

  /**
   * Returns a filter clone by id adding metada default conditions
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {String} id filter id
   *
   * @return {FiltersItem}
   */
  getFilterCloneWithDefaults(id) {
    let filter = this.filters.getClone(id);

    if (!filter.action) {
      this.setFilterDefaultAction(filter);
    }

    if (!filter.combine) {
      this.setFilterDefaultCombine(filter);
    }

    if (filter.conditions.length === 0) {
      this.setFilterDefaultCondition(filter);
    }

    return filter;
  }

  /**
   * Returns Filter conditions validation rules
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {FiltersItem} filter
   *
   * @return {Object}
   */
  getFilterConditionsValidationRules(filter) {
    let validation = {
      conditions : {},
      rules      : {},
    };

    filter.conditions.forEach((condition, index) => {
      validation.conditions['condition_' + index] = condition.value;
      validation.rules['condition_' + index]      = {
        'required' : true,
        'regex'    : this.metadata.conditions.values[condition.field].validation,
      }
    });

    return validation;
  }

  /**
   * Returns filter selected flags
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {FiltersItem} filter
   *
   * @return {Object}
   */
  getFilterSelectedFlags(filter) {
    let flags = [];

    for (let flag in filter.flags) {
      if (filter.flags[flag]) {
        flags.push(flag);
      }
    }

    return flags;
  }

  /**
   * Set filter default action from filters metadata
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {FiltersItem} filter
   *
   * @return {void}
   */
  setFilterDefaultAction(filter) {
    filter.action = this.metadata.getDefaultAction();
  }

  /**
   * Set filter default combine from filters metadata
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {FiltersItem} filter
   *
   * @return {void}
   */
  setFilterDefaultCombine(filter) {
    filter.combine = this.metadata.getDefaultCombine();
  }

  /**
   * Set filter default condition from filters metadata
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {FiltersItem} filter
   *
   * @return {FiltersItemCondition}
   */
  setFilterDefaultCondition(filter) {
    let condition    = filter.createCondition();
    let data         = this.metadata.getDefaultCondition();
    condition.field = data.field;
    condition.test  = data.tests[0];
    condition.type  = data.type;
    return condition;
  }
}